import React from "react";
import FagMore from "../metahuts/fag/FagMore";

const FagContainer = () => {
    return (
        <FagMore />
    )
}

export default FagContainer;